import { createMenuCmdField, EntityManagerConfig } from '../models/entity-config';
import { ProfiloUtenteRoutes } from '../modules/profilo-utente/profilo-utente.app-manager-routes';

export class ProfiloUtenteEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [
      createMenuCmdField(ProfiloUtenteRoutes.UtenteInfo),
      createMenuCmdField(ProfiloUtenteRoutes.GenRilascioUtenteList)
    ];
  }
}
